import React from "react";
import "./SearchPopup.css";

const SearchPopup = () => {
  return (
    <div className="search-popup">
      <h2>Search</h2>
      <div className="top-search">
        <label>Destination</label>
        <input type="text" placeholder="Enter destination" />
        <label>Check-in Date</label>
        <input type="text" placeholder="06/24/2022 to 06/24/2022" />
      </div>

      <h4>Options</h4>
      <div className="option-search">
        <label>Min price per night</label>
        <input type="number" />
      </div>
      <div className="option-search">
        <label>Max price per night</label>
        <input type="number" />
      </div>
      <div className="option-search">
        <label>Adults</label>
        <input type="number" defaultValue={1} />
      </div>
      <div className="option-search">
        <label>Children</label>
        <input type="number" defaultValue={0} />
      </div>
      <div className="option-search">
        <label>Rooms</label>
        <input type="number" defaultValue={1} />
      </div>

      <button className="search-button-page">Search</button>
    </div>
  );
};

export default SearchPopup;
